import { RefiDetail } from '../types/refinance'
import { ARM_MORTGAGE_TYPE, FIX_MORTGAGE_TYPE } from '../constants/loan'

export const filterMortgageRatesAndSort = (options: RefiDetail[]) => {
  return options
    .filter((option: RefiDetail) => {
      if (
        option.type === FIX_MORTGAGE_TYPE &&
        (option.term === 15 || option.term === 30)
      ) {
        return option
      } else if (option.type === ARM_MORTGAGE_TYPE && option.years === 5) {
        return option
      } else {
        return null
      }
    })
    .sort((option1: RefiDetail, option2: RefiDetail) => {
      // Sort for all FIXED options first (order those by term desc)
      // Sort for all ARM options second (order by asc)
      if (option1.type === option2.type) {
        return option1.term < option2.term ? 1 : -1
      }

      return option1.type < option2.type ? 1 : -1
    })
}
